import { v4 as uuid } from "uuid";
import * as types from "./types";

export const requestPeriods = () => {
  return {
    type: types.FETCH_PERIODS_REQUEST
  }
};

export const receivePeriods = (periods) => {
  return {
    type: types.FETCH_PERIODS_SUCCESS,
    periods
  }
};

export const requestPeriodsFailure = (message) => {
  return {
    type: types.FETCH_PERIODS_FAILURE,
    message
  }
};

export const setNewUser = () => {
  return {
    type: types.SET_NEW_USER,
    newUser: true
  }
};

export const unsetNewUser = () => {
  return {
    type: types.SET_NEW_USER,
    newUser: false
  }
};

export const addAlert = (style, message) => {
  return {
    type: types.ADD_ALERT,
    alert: {
      style,
      message,
      id: uuid()
    }
  }
};

export const removeAlert = (id) => {
  return {
    type: types.REMOVE_ALERT,
    id
  }
};

// export const setUser = (user) => {
//   return {
//     type: types.SET_USER,
//     user
//   }
// };

export const setApplication = (application) => {
  return {
    type: types.SET_APPLICATION,
    application
  }
};